import React from "react";

function ModalTitle({ children, className = "", size = "m" }) {
  let sizeClass = null;
  let afterClass = null;

  switch (size) {
    default:
    case "m":
      sizeClass = "text-2xl";
      afterClass = "after:mt-3";
      break;

    case "s":
      sizeClass = "text-lg";
      afterClass = "after:mt-1";
      break;
  }

  return (
    <h5
      className={`font-[OmnesMedium] text-white ${sizeClass} ${afterClass} mb-3  ${className}`}
    >
      {children}
    </h5>
  );
}

export default ModalTitle;
